import { HelperSummary } from '@my-helpers/common';
import { ElementType } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, FormControl, FormControlLabel, Radio, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { RadioGroup } from '@mui/material';

export interface ParticipantsProps {
    participants?: HelperSummary[];
    selectedParticipant?: string;
    setSelectedParticipant: (participantId?: string) => void;
    isLoading?: string;
}

export const Participants: ElementType<ParticipantsProps> = ({
    isLoading,
    participants,
    selectedParticipant, 
    setSelectedParticipant
}) => {

    return (
        <Accordion
            disableGutters
            sx={{ width: '100%' }}
        // defaultExpanded={starting}
        >
            <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="participant-content"
                id="participant-header"
            >
                <Typography
                    variant="body1"
                    component="span"
                    sx={{ color: 'text.primary' }}
                >
                    Participant
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0, pb: 1 }}>
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        value={selectedParticipant || ''}
                        name="radio-buttons-group"
                        onChange={(e) => setSelectedParticipant(e.target.value)}
                    >
                        {!isLoading && participants?.map((participant: HelperSummary) => (
                            <FormControlLabel
                                key={participant.id}
                                value={participant.id}
                                control={
                                    <Radio 
                                        size="small" 
                                        checked={selectedParticipant === participant.id} 
                                        />}
                                label={
                                    <Typography variant="body2" color="text.secondary">
                                        {participant.name}
                                    </Typography>
                                }
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </AccordionDetails>
        </Accordion>
    )
}